export const ONBOARDING_SETTINGS_URL = 'onboarding-settings/v1/settings';
export const ONBOARDING_SETTINGS_INTERNAL_URL = 'onboarding-settings/v1/internal/settings';
export const ONBOARDING_SETTINGS_ENROLLMENT_URL = 'onboarding-settings/v1/user-guide-enrollment';